import React, { FC, useEffect, useMemo, useRef, useState } from 'react'

import { theme as themeHhg, IconProps } from '@hhgtech/hhg-components'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Select, Text } from '@hhgtech/hhg-components/mantine'
import { BabyBoyMB, BabyGirlMB } from '@hhgtech/icons/other'
import { Box, DefaultProps, Selectors, RadioGroupProps } from '@mantine/core'
// import { useTranslations } from 'src/hooks'
import { useIntl } from 'react-intl'

import useStyles from './index.styles'
// import { IconProps } from '../icons'
import { Item } from './item'

export type GenderOptionSelectProps = {
  value: string
  label: string
  icon: string | FC<IconProps>
}
export interface Props extends DefaultProps<Selectors<typeof useStyles>> {
  label?: string
  availableValue?: string
  isBaby?: boolean
  genderValue?: {
    male: string
    female: string
  }
  hideLabel?: boolean
  type?: 'button' | 'radio'
  onChange?: (value: string) => void
}
const GenderOptionSelectControl = ({
  label,
  availableValue: availableValueInit,
  styles,
  isBaby,
  genderValue = {
    male: 'male',
    female: 'female',
  },
  type = 'button',
  ...restProps
}: // hideLabel,
Props & Omit<RadioGroupProps, 'children' | 'styles'>) => {
  const { formatMessage: f } = useIntl()
  const { classes, theme } = useStyles(
    { type },
    {
      name: 'GenderOptionSelectControl',
      styles,
    },
  )
  const isMarryBaby = theme.other.template === 'mb'
  const [availableValue, setAvailableValue] = useState<string>()
  const ref = useRef<HTMLDivElement>(null)
  const [value, setValue] = useState<string | null>(null)
  const genderOptions = useMemo(
    () =>
      [
        {
          value: genderValue.male,
          label: isBaby ? f({ id: 'gender.boy' }) : f({ id: 'gender.male' }),
          icon: isBaby ? (
            isMarryBaby ? (
              <BabyBoyMB />
            ) : (
              CommonGAssets.getAssetPath('health-tools/boy-icon.svg')
            )
          ) : (
            CommonGAssets.getAssetPath('health-tools/male-icon.svg')
          ),
        },
        {
          value: genderValue.female,
          label: isBaby ? f({ id: 'gender.girl' }) : f({ id: 'gender.female' }),
          icon: isBaby ? (
            isMarryBaby ? (
              <BabyGirlMB />
            ) : (
              CommonGAssets.getAssetPath('health-tools/girl-icon.svg')
            )
          ) : (
            CommonGAssets.getAssetPath('health-tools/female-icon.svg')
          ),
        },
      ] as GenderOptionSelectProps[],
    [],
  )
  useEffect(() => {
    setAvailableValue(availableValueInit)
    setValue(availableValueInit || null)
  }, [availableValueInit])
  return (
    <Box ref={ref} className={classes.root}>
      <Select
        label={
          <Text size="s4" weight="semiBold" color={themeHhg.colors.gray600}>
            {label}
          </Text>
        }
        itemComponent={Item}
        data={genderOptions}
        // value={value}
        placeholder={f({ id: 'common.placeholder' })}
        icon={
          value && (
            <img
              src={
                genderOptions.filter((i) => i.value === value)?.[0]
                  .icon as string
              }
              alt={genderOptions.filter((i) => i.value === value)?.[0].label}
              loading="eager"
            />
          )
        }
        {...restProps}
        // onChange={setValue}
        styles={{
          icon: {
            img: {
              width: 20,
            },
          },
          input: {
            '&:disabled': {
              color: theme.colors.gray[9],
            },
          },
          item: {
            '&[data-selected]': {
              '.text': {
                color: '#fff',
              },
            },
          },
        }}
        disabled={Boolean(availableValue)}
      />
      {/* <Radio.Group
        className="radio-group"
        label={
          !hideLabel ? (
            <Text as="label" size="s4" weight="semiBold">
              {label ||
                (isBaby
                  ? t('tools.selectBabyGender')
                  : t('tools.selectGender'))}
            </Text>
          ) : undefined
        }
        size="lg"
        {...radioProps}
        classNames={{
          error: classes.groupErr,
        }}
        {...(type === 'radio' && {
          error: null,
        })}
      >
        <Flex className={cx(classes.wrapper)}>
          {genderOptions.map((i) => (
            <Radio
              className="gender-item"
              size="sm"
              classNames={{
                root: classes.itemRoot,
                labelWrapper: classes.itemLabelWrapper,
                label: classes.itemLabel,
                inner: classes.itemInner,
                body: classes.itemBody,
              }}
              key={i.value}
              value={i.value}
              {...(availableValue &&
                i.value !== availableValue && {
                  disabled: true,
                })}
              label={
                <Flex
                  gap={rem(8)}
                  align={'center'}
                  justify={'center'}
                  sx={{ zIndex: 0 }}
                >
                  {type === 'button' &&
                    (typeof i.icon === 'string' ? (
                      <img
                        src={i.icon}
                        className="gender-image"
                        alt="female"
                        loading="lazy"
                      />
                    ) : (
                      i.icon
                    ))}
                  <Text size="p3">{i.label}</Text>
                </Flex>
              }
            />
          ))}
        </Flex>
      </Radio.Group> */}
    </Box>
  )
}

export { GenderOptionSelectControl }
